module.exports = __webpack_public_path__ + "img/binance.c8a1cb59.svg";